import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import AuthContext from '@providers/context/componenets/AuthContext'

export default function AuthGuard() {
    const { isAuthenticated } = useContext(AuthContext)

    

    if (!isAuthenticated) {
        return <Navigate to='/login' replace />
    }

    return <Outlet />
}